import { t } from '../i18n';

/**
 * Deactivating someone bans their Supabase login, so the auth server refuses
 * the sign-in itself. These helpers are how the portal recognises that refusal
 * and what it says, so every screen says the same thing.
 */

/** `?reason=` value the marketing sign-in page shows the same message for. */
export const ACCOUNT_DEACTIVATED_REASON = 'account-deactivated';

/** Call during render, after `useI18n()`, so it follows a change of language. */
export const accountDeactivatedMessage = (): string => (
  t('Your account has been deactivated, please contact your company administrator.')
);

/**
 * True for the error Supabase Auth returns to a banned account, on sign-in
 * ("User is banned") and on token refresh ("Invalid Refresh Token: User Banned").
 */
export function isAccountDeactivatedError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const { code, message } = error as { code?: unknown; message?: unknown };
  if (code === 'user_banned') return true;
  return typeof message === 'string' && /user[ _](is )?banned/i.test(message);
}
